export const SET_FORM_DIRTY = 'SET_FORM_DIRTY';

export const setIsFormDirty = (value) => ({
    type: SET_FORM_DIRTY,
    isFormDirty: value,
});
